var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.019 16.82L18.889 9.5C18.319 8.16 17.469 7.4 16.499 7.35C15.539 7.3 14.609 7.97 13.899 9.25L11.999 12.66C11.599 13.38 11.029 13.81 10.409 13.86C9.779 13.92 9.149 13.59 8.639 12.94L8.419 12.66C7.709 11.77 6.829 11.34 5.929 11.43C5.029 11.52 4.259 12.14 3.749 13.15L2.019 16.6C1.399 17.85 1.459 19.3 2.189 20.48C2.919 21.66 4.189 22.37 5.579 22.37H18.339C19.679 22.37 20.929 21.7 21.669 20.58C22.429 19.46 22.549 18.05 22.019 16.82ZM6.97 8.381C7.86643 8.381 8.72615 8.0249 9.36002 7.39102C9.99389 6.75715 10.35 5.89743 10.35 5.001C10.35 4.10457 9.99389 3.24485 9.36002 2.61098C8.72615 1.97711 7.86643 1.621 6.97 1.621C6.07357 1.621 5.21385 1.97711 4.57998 2.61098C3.94611 3.24485 3.59 4.10457 3.59 5.001C3.59 5.89743 3.94611 6.75715 4.57998 7.39102C5.21385 8.0249 6.07357 8.381 6.97 8.381Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f72f2b1fe6f9ae00669fb6752539dd30.svg";
export { ForwardRef as ReactComponent };